// extracted by mini-css-extract-plugin
module.exports = {"container":"error-offer_container__GPVmM","info":"error-offer_info__hnh1x","error":"error-offer_error__3Mbv3","text":"error-offer_text__lDk2g","icon":"error-offer_icon__2xBEq"};